import discardNullableValues from '@haaretz/s-common-utils/discardNullableValues';
import fetchUtility from '@haaretz/s-fetch-utility';
import mergeURLSearchParams from '@haaretz/s-navigation-utils/mergeURLSearchParams';
import { useMutation } from '@tanstack/react-query';
export default function useClientMutation({ url, body, clientOptions, fetchOptions, searchParams, transformResponse, cacheKey }) {
    const isGetRequest = fetchOptions?.method === 'GET';
    const fetchSearchParam = mergeURLSearchParams(body ? new URLSearchParams(discardNullableValues(body)) : undefined, searchParams, {
        mergeMethod: 'set'
    });
    return useMutation([
        'all',
        cacheKey,
        url,
        fetchSearchParam?.toString(),
        ...body === undefined ? [] : [
            body
        ]
    ].filter(Boolean), async (mutationBody)=>{
        const fetchSearchParamMerged = mergeURLSearchParams(mutationBody && isGetRequest ? new URLSearchParams(discardNullableValues(mutationBody)) : undefined, fetchSearchParam, {
            mergeMethod: 'set'
        });
        const result = await fetchUtility({
            url,
            searchParams: fetchSearchParamMerged,
            headers: fetchOptions?.headers ? {
                ...fetchOptions.headers
            } : {},
            ...isGetRequest ? {
                method: 'GET'
            } : {
                method: 'POST',
                body: mutationBody || body
            },
            options: {
                cache: 'no-cache'
            }
        })({});
        return transformResponse ? transformResponse(result) : result;
    }, {
        ...clientOptions,
        useErrorBoundary: false
    });
}

//# sourceMappingURL=useClientMutation.js.map